<template lang="pug">
.feature
  .row.apart
    .col
      .feature-vote(
        @click.prevent="vote",
        :class="{ liked: selected.isLiked, disabled: selected.isReadOnly }"
      )
        .feature-vote-top
          .feature-vote-icon
            font-awesome-icon.icon(:icon="['fas', 'caret-up']")
          .feature-vote-count
            span {{ selected.stats.likes }}
        //-.feature-vote-button
          span Vote

    .col.max
      .row.apart.center.feature-title
        .col
          h3 {{ selected.name }}

      .feature-status(v-if="selected.status && !selected.status.default")
        StatusLabel(:status="selected.status")

      .feature-body(v-html="descriptionFormatted")

      .feature-attachments(v-if="selected.attachments")
        a.feature-attachment(
          v-for="attachment in selected.attachments",
          @click.stop,
          :href="attachment.url",
          target="_blank"
        )
          img(:src="attachment.url")

      //-.feature-attachment(v-if="selected.attachmentUrl")
        a(target="_blank", :href="selected.attachmentUrl")
          img(:src="selected.attachmentUrl")

      .feature-footer
        .row.center
          .col.feature-footer-avatar
            UserAvatar(:user="selected.creator")
          .col
            .creator
              span {{ selected.creator.fullName }}
              span(v-if="['web', 'widget'].indexOf(selected.source) === -1")
                | via
                font-awesome-icon.icon(v-if="selected.source === 'intercom'", :icon="['fab', 'intercom']")
                font-awesome-icon.icon(v-if="selected.source === 'slack'", :icon="['fab', 'slack']")
                span.missing-icon(v-if="selected.source === 'zapier'") Zapier
                span.missing-icon(v-if="selected.source === 'import'") Import
            .created
              time(:datetime="selected.created") {{ selected.created | moment('from') }}
    .col.feature-comments
      font-awesome-icon.feature-comments-icon(:icon="['fad', 'comments']")
      span {{ selected.stats.comments }}

</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'BoardFeatureSelected',
  components: {
  },
  data () {
    return {
      thisFeature: {
        stats: {},
        creator: {}
      }
    }
  },
  mounted () {
    //this.thisFeature = this.feature
    //console.log(this.thisFeature)
  },
  computed: {
    ...mapState({
      selected: state => state.features.selected
    }),
    descriptionFormatted () {
      return this.selected.description ? this.selected.description.replace(/\n/g, '<br/>') : ''
    }
  },
  methods: {
    vote () {
      const slug = this.selected.slug
      if (this.selected.isLiked) {
        this.$store.dispatch('features/unvoteFeature', slug).then(() => {
          //this.thisFeature.stats.likes--
          //this.thisFeature.isLiked = false
        }, () => {

        })
      } else {
        this.$store.dispatch('features/voteFeature', slug).then(() => {
          //this.thisFeature.stats.likes++
          //this.thisFeature.isLiked = true
        }, () => {
        })
      }
    }
  },
  watch: {
    selected (feature) {
      console.log('feature changed')
      console.log(feature)
      //this.thisFeature = feature
    }
  }
}
</script>

<style scoped lang="stylus">
  .feature
    //border-bottom $border-default
    display block
    margin-bottom $spacing-2
    padding $spacing 0

    //h3
    //  color $color-primary

    .feature-vote
      border $border-default
      border-radius $border-radius
      cursor pointer
      font-size $spacing-2
      margin-top 3px
      margin-right $spacing-3
      //padding $spacing-2 0
      overflow hidden
      text-align center
      transition 100ms linear
      width 50px

      &.disabled
        cursor not-allowed
        opacity .65

      +for_breakpoint(mobile)
        margin-right $spacing-2

      &.liked
        border-color $color-primary
        .feature-vote-icon
          color $color-primary
        .feature-vote-count
          color $text-default

      &:hover:not(.disabled)
        border-color $color-primary

      .feature-vote-top
        padding 5px 0 $spacing 0

      .feature-vote-icon
        color $color-black-lighter
        font-size 22px
        .icon
          height 22px

      .feature-vote-count
        //border $border-default
        //border-bottom none
        color $color-black-lighter
        //width 50px
      .feature-vote-button
        background-color $background-color-dark
        color #FFF
        font-size $text-size-smaller
        padding 2px
        text-align center
    .feature-comments
      margin-left $spacing-3
      font-size 18px
      line-height 26px
      +for_breakpoint(mobile)
        display none

      .feature-comments-icon
        height 18px
        margin-right $spacing
    .feature-title
      margin-bottom 15px
      .col
        h3
          font-size 22px
          line-height 26px
          +for_breakpoint(mobile)
            font-size 18px

    .feature-status
      margin-bottom $spacing
      margin-top -5px
    //.feature-description
    //  padding 1rem 0

    .feature-body
      color $text-light
      line-height 22px
      margin-bottom $spacing-4
      //padding $spacing 0

    .feature-attachments
      margin-bottom $spacing
    .feature-attachment
      border $border-default
      border-radius $border-radius
      display inline-block
      padding 2px
      vertical-align top
      img
        max-width 100px
        vertical-align top

    .feature-footer
      color $text-light
      margin-bottom 10px

      .feature-footer-avatar
        width 50px

      .creator
        font-size $text-size-small
        line-height $text-size-default
        span
          margin-right 5px
        .icon
          margin-left 5px
        .missing-icon
          margin-left 5px
      .created
        font-size $text-size-smaller
        line-height $text-size-default

      span
        display inline-block
        margin-right $spacing
</style>
